/* @flow */
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RequireForAccess from 'react-access';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import UserStore from 'stores/UserStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from './AddNewLink.module.scss';
import { ElectroTooltip } from '../ExtendedUiElements/customized';

export type AddNewLinkProps = {
  linkTo: string,
  linkText: string,
  permissions?: number[],
  action: string,
  disableAddNewButton?: boolean,
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  userStore: UserStore,
};

@inject('actionDrawerStore', 'userStore')
@observer
export default class AddNewLink extends ComponentWithInjectedProps<
  AddNewLinkProps,
  {},
  InjectedProps
> {
  handleAddNew = (e: Object) => {
    const {
      userStore: { activeUser, isReadOnly },
      action,
      disabled,
    } = this.props;

    if (isReadOnly || disabled) {
      e.preventDefault();
    } else if (!this.props.linkTo) {
      e.preventDefault();
      this.handleActionDrawer(action);
    }
  };

  handleActionDrawer = (currentAction: string) => {
    const { actionDrawerStore } = this.props;
    actionDrawerStore.openActionDrawer(currentAction);
  };

  renderListItem() {
    const {
      userStore: { isReadOnly },
      linkText,
      disabled,
    } = this.props;

    return (
      <ListItem
        className={styles['add-new-item']}
        button={false}
        component="div"
        onClick={this.handleAddNew}
        disabled={isReadOnly || disabled}
      >
        <ListItemIcon className={styles['add-new-icon']}>
          <svg>
            <use xlinkHref="#icon-add" />
          </svg>
        </ListItemIcon>
        <ListItemText
          disableTypography={true}
          className={styles['add-new-text']}
          primary={linkText}
        />
      </ListItem>
    );
  }

  renderLink() {
    const { tooltip } = this.props;

    return (
      <Link to={this.props.linkTo} className={styles['add-new-link']}>
        {tooltip ? (
          <ElectroTooltip title={tooltip}>{this.renderListItem()}</ElectroTooltip>
        ) : (
          this.renderListItem()
        )}
      </Link>
    );
  }

  renderPermissions() {
    return (
      <RequireForAccess permissions={this.props.permissions}>{this.renderLink()}</RequireForAccess>
    );
  }

  render() {
    return this.props.permissions ? this.renderPermissions() : this.renderLink();
  }
}
